import React from 'react';

import Markdown, {H2} from '../../components/Markdown';
import LessonCard from './LessonCard';

const QuestionCategories = ({description, categories = [], lessonMapping}) => (
  <div>
    <Markdown className="prose lg:prose-lg prose-indigo mb-10" allowRaw>{description}</Markdown>
    {categories.map((category) => (
      <QuestionCategory
        name={category.name}
        description={category.description}
        lessons={category.lessons}
        lessonMapping={lessonMapping}
        key={category.name}
      />
    ))}
  </div>
);

export const QuestionCategory = ({
  name, description, lessons = [], lessonMapping,
}) => (
  <>
    <H2 className="text-lg font-bold text-gray-800">{name}</H2>
    <Markdown className="prose lg:prose-lg prose-indigo" allowRaw>{description}</Markdown>
    {lessons.length > 0 && (
      <div className="-mx-4 mt-6 mb-12 md:mx-0 p-6 flex flex-col bg-gray-50 md:shadow-lg md:rounded-lg space-y-4">
        <span className="text-base text-gray-500 font-medium">
          {`Featured lessons on ${name}`}
        </span>
        {lessons.map((lesson) => (
          <LessonCard
            lesson={lesson}
            lessonMapping={lessonMapping}
            key={lesson.slug}
          />
        ))}
      </div>
    )}
  </>
);

export default QuestionCategories;
